import { create } from "zustand";
import { DEFAULT_NOTIFICATION_DURATION_MS } from "./constants.js";
import { IconColor } from "./icons/Icon.js";
import { IconAlert } from "./icons/IconAlert.js";
import { IconDanger } from "./icons/IconDanger.js";
import { IconSuccess } from "./icons/IconSuccess.js";
import { IconTooltip } from "./icons/IconTooltip.js";
const useNotificationStore = create(()=>({
        isPaused: false,
        notifications: []
    }));
const createNotification = (notificationVariant)=>(options)=>{
        setTimeout(()=>{
            const id = crypto.randomUUID();
            const notification = {
                isFirstMount: true,
                id,
                duration: DEFAULT_NOTIFICATION_DURATION_MS,
                ...options,
                ...notificationVariant
            };
            useNotificationStore.setState((state)=>({
                    notifications: [
                        ...state.notifications,
                        notification
                    ]
                }));
        });
    };
const actions = {
    clear: ()=>{
        useNotificationStore.setState({
            notifications: []
        });
    },
    dismiss: (notificationId)=>{
        useNotificationStore.setState((state)=>({
                notifications: state.notifications.filter((notifications)=>notifications.id !== notificationId)
            }));
    },
    info: createNotification({
        color: IconColor.Primary,
        icon: IconTooltip
    }),
    success: createNotification({
        color: IconColor.Success,
        icon: IconSuccess
    }),
    warning: createNotification({
        color: IconColor.Alert,
        icon: IconAlert
    }),
    error: createNotification({
        color: IconColor.Danger,
        icon: IconDanger
    })
};
export { actions, useNotificationStore };
